import { wealthProApi } from '../../redux/api';
import _ from "lodash";

const custodianCashBalancesApiEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        searchCashBalances: builder.query({
            query: (data) => ({
                url: `api/valuations/custodianbalance`,
                method: 'POST',
                body: data,
            }),
            transformResponse: (response, _, { cacheKey }) => {
                return { cacheKey, ...response };
            },
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                // const { cacheKey } = queryArgs || {};
                // return `${endpointName}-${cacheKey}`
                return endpointName;
            },
            merge: (currentCache, newItems) => {
                if (_.isEqual(currentCache.cacheKey, newItems.cacheKey)) {
                    currentCache.pagination = newItems.pagination;
                    currentCache.results.push(...newItems.results);
                }
                else {
                    currentCache.cacheKey = newItems.cacheKey;
                    currentCache.pagination = newItems.pagination;
                    currentCache.results = [...newItems.results];
                }             
            }
        }),
       
    }),
});

export const {
    useLazySearchCashBalancesQuery,
} = custodianCashBalancesApiEndpoints;

